export default __webpack_public_path__ + "static/media/bg5.899b3c16.jpg";